import styled from '@emotion/styled';
import { ClickableThemeProps } from '@theme/base';

interface NavLabelProps extends ClickableThemeProps {
  noIcon?: boolean;
}
export const NavLabel: any = styled.span(({ theme, isClickable, noIcon }: NavLabelProps) => ({
  ['&, a, a:visited']: {
    padding: 10,
    whiteSpace: 'nowrap',
    paddingLeft: noIcon ? 10 : theme.custom.spacing.large,
    paddingRight: 0,
    cursor: isClickable ? 'pointer' : 'default',
    ...(theme.custom.typography.paragraph as any),
    fontWeight: 500,
    lineHeight: '2.7rem',
    color: theme.custom.colors.white,
    textDecoration: 'none',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.7)',
    ['&:hover']: {
      color: theme.custom.colors.group1.base
    }
  }
}));
